// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__8aIdV","text":"SelectPayment_text__2MY7F","title":"SelectPayment_title__cxk64","btn":"SelectPayment_btn__hT5fr"};